import { useMemo } from "react";
import { useDataMode } from "../context/DataContext";
import useFirestoreCollection from "./useFirestoreCollection";

export const useContacts = () => {
  const { useCloudDatabase, localContacts } = useDataMode();
  const { docs: cloudContacts } = useFirestoreCollection("contacts");

  const contacts = useMemo(() => {
    if (useCloudDatabase) {
      return cloudContacts;
    }
    return localContacts;
  }, [useCloudDatabase, cloudContacts, localContacts]);

  return { docs: contacts };
};

export const useItems = () => {
  const { useCloudDatabase } = useDataMode();
  const { docs: cloudItems } = useFirestoreCollection("items", { orderBy: null });

  const items = useMemo(() => {
    if (useCloudDatabase) {
      return cloudItems;
    }
    return []; // No local items in demo mode
  }, [useCloudDatabase, cloudItems]);

  return { docs: items };
};

export const useComments = () => {
  const { useCloudDatabase } = useDataMode();
  const { docs: cloudComments } = useFirestoreCollection("comments", { orderBy: null });

  const comments = useMemo(() => {
    if (useCloudDatabase) {
      return cloudComments;
    }
    return []; // No local comments in demo mode
  }, [useCloudDatabase, cloudComments]);

  return { docs: comments };
};

export const useDocuments = () => {
  const { useCloudDatabase } = useDataMode();
  const { docs: cloudDocuments } = useFirestoreCollection("client-documents", { orderBy: null });

  const documents = useMemo(() => {
    if (useCloudDatabase) {
      return cloudDocuments;
    }
    return []; // No local documents in demo mode
  }, [useCloudDatabase, cloudDocuments]);

  return { docs: documents };
};

export const useProjects = () => {
  const { useCloudDatabase, localProjects } = useDataMode();
  const { docs: cloudProjects } = useFirestoreCollection("projects", { orderBy: null });

  const projects = useMemo(() => {
    if (useCloudDatabase) {
      return cloudProjects;
    }
    return localProjects;
  }, [useCloudDatabase, cloudProjects, localProjects]);

  return { docs: projects };
};
